import pendingTransferMinimalDenomAtom from './atom';

export default pendingTransferMinimalDenomAtom;
